import { StyleCategoryMap } from '../types';

/**
 * Mapping object between CSS style properties (boxShadow, padding, etc)
 * accepted by components (as defined in the `types/[propcategory]-style.ts`
 * files) and their corresponding token categories (fontSize, space, etc).
 * These properties are the only ones that have semantic or component
 * token values defined in the design system. E.g:
 *
 * `<View padding="1000">...</View>`
 *
 * Here, the `padding` prop is mapped to the `space` token category
 * of the theme object.
 */
export const styleCategoryMap: StyleCategoryMap = {
  // Background
  backgroundColor: 'color',

  // Box shadow
  boxShadow: 'boxShadow',

  // Border
  borderWidth: 'borderWidth',
  borderBlockWidth: 'borderWidth',
  borderBlockStartWidth: 'borderWidth',
  borderBlockEndWidth: 'borderWidth',
  borderInlineWidth: 'borderWidth',
  borderInlineStartWidth: 'borderWidth',
  borderInlineEndWidth: 'borderWidth',
  borderRadius: 'borderRadius',
  borderStartStartRadius: 'borderRadius',
  borderStartEndRadius: 'borderRadius',
  borderEndStartRadius: 'borderRadius',
  borderEndEndRadius: 'borderRadius',
  borderColor: 'color',
  borderBlockColor: 'color',
  borderBlockStartColor: 'color',
  borderBlockEndColor: 'color',
  borderInlineColor: 'color',
  borderInlineStartColor: 'color',
  borderInlineEndColor: 'color',

  // Layout
  gap: 'space',
  rowGap: 'space',
  columnGap: 'space',

  // Position
  inset: 'space',
  insetBlockStart: 'space',
  insetBlockEnd: 'space',
  insetInlineStart: 'space',
  insetInlineEnd: 'space',

  // Space
  padding: 'space',
  paddingInline: 'space',
  paddingInlineStart: 'space',
  paddingInlineEnd: 'space',
  paddingBlock: 'space',
  paddingBlockStart: 'space',
  paddingBlockEnd: 'space',
  margin: 'space',
  marginInline: 'space',
  marginInlineStart: 'space',
  marginInlineEnd: 'space',
  marginBlock: 'space',
  marginBlockStart: 'space',
  marginBlockEnd: 'space',

  // Text
  color: 'color',
  typography: 'typography',
};
